export const BOTTOM_NAV_BASE_HEIGHT = 56;
